import Menu from './Menu'

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu/index.js